import React from 'react';
//import React, { useEffect } from 'react';


import FormField from './FormField/FormField';

import initFormState from '../FormUtils/initFormState';
import arrayFormToHash from '../FormUtils/arrayFormToHash';
import { extractValuesFromStore } from '../FormUtils';
import Button from '../../Button/Button';

import checkValidity from './checkValidity';

import styles from './FormGenerator.module.css';


const FormGenerator = (props) => {
  const isValid = false;

  let submitButton = null;
  if (props.onSubmit) {
    submitButton = <>
                    <div className={styles.Break}></div>
                    <div className={styles.InputContainer}>
                      <Button btnType="Success" 
                              disabled={!props.isValid}>{props.submitButtonLabel || props.label || 'Submit'}
                      </Button>
                    </div>
                   </>
  }

  let formEntries = [];
  if (Array.isArray( props.entries )) {
    formEntries = props.entries.map( v => (
      <FormField
        key={v.fieldname}
        name={v.fieldname}
        className={v.classname}
        containerClasses={v.containerclasses}
        labelClasses={v.labelclasses}
        inputClasses={v.inputclasses}
        tag={v.tag}
        label={v.label}
        attributes={v.attributes}
        shouldValidate={v.validation}
        errorMessage={v.errorMessage}
        absentValueMessage={v.absentValueMessage}
        selectOptions={v.selectOptions}
        invalid={!props.state[v.fieldname].valid}
        value={props.state[v.fieldname].value}
        touched={props.state[v.fieldname].touched}
        onChange={(event) => props.onChange(event, v.fieldname)} 
      />
    ))
  } else {
    formEntries = Object.keys( props.entries ).map( key => (
      <FormField
        key={key}
        name={key}
        className={props.entries[key].classname}
        containerClasses={props.entries[key].containerclasses}
        labelClasses={props.entries[key].labelclasses}
        inputClasses={props.entries[key].inputclasses}
        tag={props.entries[key].tag}
        label={props.entries[key].label}
        attributes={props.entries[key].attributes}
        shouldValidate={props.entries[key].validation}
        errorMessage={props.entries[key].errorMessage}
        absentValueMessage={props.entries[key].absentValueMessage}
        selectOptions={props.entries[key].selectOptions}
        invalid={!props.state[key].valid}
        value={props.state[key].value}
        touched={props.state[key].touched}
        onChange={(event) => props.onChange(event, key)} 
      />
    ))
  }

  let form = (
    <form onSubmit={props.onSubmit}>
      <div className={styles.formcontainer}>
        {formEntries}
        {submitButton}
      </div>
    </form>
  )

  return (
    <div className={styles.formcontainer}>
      {form}
    </div>
  )
}

FormGenerator.initFormState = initFormState;
FormGenerator.extractValuesFromStore = extractValuesFromStore; //@Todo legacy export
FormGenerator.arrayFormToHash = arrayFormToHash;

export default FormGenerator;


/*
props: 
entries
name
onChange
onSubmit
submitButtonLabel
*/

/*
<div containerclasses>
  <div><label labelclasses></div>
  <div inputclasses><input classnames></div>
</div>
entries = {
    fieldname: {
        tag: 'input' | 'select' | 'textarea' | 'boxes' | 'switch',
        label:
        classname: 'class1 class2', JaNein
        containerclasses: TwoCols
        labelclasses: not yet
        inputclasses: not yet
        attributes: {       (=attributes to html input)
            type: 'text' | 'email' 
            type: ('text') | 'checkbox' | 'radio'   => for boxes
            options: ['foo', 'bar', {label:'a long label', value: 'baz'}], => for boxes
            checked: ['foo', 'bar'] => for checkboxes
            placeHolder: 
        },
        selectOptions: [ { value: '', displayValue '' } ],  => for select
        validation: {
            required: true | false
            minLength
            maxLength
            isNumeric
        },
        errorMessage: '',
        absentValueMessage: '',
        errorMessages: { validation: 'error' },    // not yet
        value:
    }
    ...
}

special entries:
Xlinebreak...: {}
Xsmallskip...:{}
Xmedskip...:{}
Xbigskip...:{}
Xtext...:{ value: "text" }
...: unique ID
*/